import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FiArrowUpRight, FiMenu, FiX } from 'react-icons/fi';
import './public.css';

// This theme and all public styles are isolated from the staff dashboard.
const publicTheme = createTheme({
    palette: { primary: { main: '#376b55' } },
    typography: { fontFamily: "'Segoe UI', Arial, sans-serif", button: { textTransform: 'none' } },
    shape: { borderRadius: 6 },
});

export function ClinicBrand() {
    return (
        <Link to="/" className="hc-brand" aria-label="Horizont Medical Center home">
            <span className="hc-logo-window"><img src={`${process.env.PUBLIC_URL}/horizont-clinic.png`} width="1672" height="941" alt="Horizont Medical Center" /></span>
        </Link>
    );
}

export function PublicButton({ children, to, href, secondary = false, ...props }) {
    const className = `hc-button${secondary ? ' hc-button-secondary' : ''}`;
    const contents = <>{children}<FiArrowUpRight aria-hidden="true" /></>;
    return to ? <Link className={className} to={to} {...props}>{contents}</Link>
        : <a className={className} href={href} {...props}>{contents}</a>;
}

export default function PublicLayout({ children, title = 'Horizont Medical Center' }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuButton = useRef(null);
    const location = useLocation();

    useEffect(() => {
        const previousTitle = document.title;
        document.title = title;
        return () => { document.title = previousTitle; };
    }, [title]);

    useEffect(() => { setMenuOpen(false); }, [location.pathname]);

    const closeOnEscape = (event) => {
        if (event.key === 'Escape') {
            setMenuOpen(false);
            menuButton.current?.focus();
        }
    };

    return (
        <ThemeProvider theme={publicTheme}>
            <div className="hc-site" onKeyDown={closeOnEscape}>
                <a className="hc-skip-link" href="#main-content">Skip to content</a>
                <header className="hc-header">
                    <div className="hc-container hc-header-inner">
                        <ClinicBrand />
                        <button ref={menuButton} type="button" className="hc-menu-toggle"
                            aria-expanded={menuOpen} aria-controls="public-navigation"
                            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
                            onClick={() => setMenuOpen(open => !open)}>
                            {menuOpen ? <FiX /> : <FiMenu />}
                        </button>
                        <nav id="public-navigation" className={`hc-navigation${menuOpen ? ' is-open' : ''}`} aria-label="Main navigation">
                            <NavLink to="/" end onClick={() => setMenuOpen(false)}>Home</NavLink>
                            <a href="/#opening-hours" onClick={() => setMenuOpen(false)}>Opening hours</a>
                            <NavLink to="/login" onClick={() => setMenuOpen(false)}>Login <FiArrowUpRight aria-hidden="true" /></NavLink>
                        </nav>
                    </div>
                </header>
                <main id="main-content" tabIndex="-1">{children}</main>
                <footer className="hc-footer">
                    <div className="hc-container hc-footer-main">
                        <ClinicBrand />
                        <p>Opening hours<br /><span>Every day · 17:00–20:00</span></p>
                        <nav aria-label="Footer navigation">
                            <Link to="/">Home</Link>
                            <Link to="/login">Login <FiArrowUpRight aria-hidden="true" /></Link>
                        </nav>
                    </div>
                    <div className="hc-container hc-footer-bottom">
                        <span>© {new Date().getFullYear()} Horizont Clinic</span>
                        <span>HORIZONT MEDICAL CENTER</span>
                    </div>
                </footer>
            </div>
        </ThemeProvider>
    );
}
